import { useSearchParams } from 'react-router-dom'
import AuthContainer from '../components/auth/AuthContainer'

const LoginScreen = () => {
  const [params] = useSearchParams()

  const from = params.get('from')

  return (
    <div className="h-auto flex justify-center items-center">
      <AuthContainer mode="login" from={from} />
    </div>
  )
}

export default LoginScreen
